/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgConveyerBelt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M18.707 8.293 22.414 12l-3.707 3.707-1.414-1.414L19.586 12l-2.293-2.293zM7 9v6H1V9zm8 0v6H9V9zM5 11H3v2h2zm8 0h-2v2h2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgConveyerBelt as ConveyerBelt };
